import { render, staticRenderFns } from "./weekPopover.vue?vue&type=template&id=1dc46648&scoped=true"
import script from "./weekPopover.vue?vue&type=script&lang=js"
export * from "./weekPopover.vue?vue&type=script&lang=js"
import style0 from "./weekPopover.vue?vue&type=style&index=0&id=1dc46648&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc46648",
  null
  
)

export default component.exports